const Tick = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Tick</title>
    <path d="M18.6793 7.28939C18.4923 7.10418 18.2376 7 17.972 7C17.7064 7 17.4518 7.10418 17.2647 7.28939L9.84331 14.5877L6.72531 11.5157C6.46372 11.2676 6.0872 11.1753 5.73758 11.2737C5.38795 11.3721 5.11834 11.6462 5.0303 11.9928C4.94226 12.3393 5.04917 12.7057 5.31075 12.9539L9.13603 16.7106C9.32307 16.8958 9.57769 17 9.84331 17C10.1089 17 10.3635 16.8958 10.5506 16.7106L18.6793 8.72752C18.8837 8.54231 19 8.2816 19 8.00845C19 7.73531 18.8837 7.4746 18.6793 7.28939Z" />
  </svg>
);

export { Tick };
